import { roundToPlaces } from "../../utils/roundToPlaces.js";

export function calculatePriceWithTax(priceWithTax: number, taxRate: number): number {
	const taxCoefficient = 1 + taxRate / 100;
	const withTax = priceWithTax * taxCoefficient;
	return roundToPlaces(withTax, 2);
}
